export const select2SchedulePeriodOption = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}
export const select2ScheduleVersionOption = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}